export default function textreplace(input, replaceWhat, replaceWith) {

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
  let regEx = new RegExp(escapeRegExp(replaceWhat), "gi");
  let result = input.replaceAll(regEx, replaceWith);
  return result
}
